// historyUtils.tsx (or a similar utility file)
import { useNavigate } from 'react-router-dom';

// Create a custom hook to provide the navigate function
export const useAppNavigation = () => {
  const navigate = useNavigate();
  return navigate;
};